import { render } from "./ProfessionalInsurance.vue?vue&type=template&id=67128930"
import script from "./ProfessionalInsurance.vue?vue&type=script&lang=js"
export * from "./ProfessionalInsurance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__